import { useEffect } from 'react';
import { URLSearchParamsInit } from 'react-router-dom';
import {
  IUseTablePreserverEncoderConfigItem,
  TUseTablePreserverEncoderConfigs,
} from '../interfaces';
import { TSetSearchParams } from '../../../interfaces';
import { tablePreserverDefaultParser } from '../helpers';
import useCachedValue from '../../useCachedValue';

const useTablePreserverEncoder = <TParams>(
  setSearchParams: TSetSearchParams,
  config: TUseTablePreserverEncoderConfigs<TParams>,
): void => {
  const cachedConfig = useCachedValue(config);

  useEffect(() => {
    const state: URLSearchParamsInit = {};
    Object.entries(cachedConfig).forEach(([name, configOrValue]) => {
      let value;
      let parser;
      if (typeof configOrValue === 'object') {
        value = (configOrValue as IUseTablePreserverEncoderConfigItem).value;
        parser = (
          configOrValue as IUseTablePreserverEncoderConfigItem
        ).parser ?? tablePreserverDefaultParser;
      } else {
        value = configOrValue;
        parser = tablePreserverDefaultParser;
      }
      if (value === undefined || value === '') {
        return;
      }
      state[name] = parser(value);
    });
    setSearchParams(state, { replace: true });
  }, [cachedConfig, setSearchParams]);
};

export default useTablePreserverEncoder;
